import loadable from '@loadable/component';

export const CheckoutBillingAddressContainerLoadable = loadable(
  () => import('./CheckoutBillingAddressContainer'),
  { resolveComponent: (module) => module.CheckoutBillingAddressContainer },
);
